/* KITSU, 08.10.2026: ein einziger „Get notified"-Knopf, überall gleich.
   Vorlage ist der Knopf aus sections/campaign-product-cards.liquid auf der Startseite:
   Theme-Klassen, Glocken-Icon, Text „Get notified", Klick öffnet Stoqs Anmeldeformular über
   window._RestockRocket.openModal. Stoqs eigene Buttons werden per CSS ausgeblendet, damit
   Aussehen und Hover ausschließlich vom Theme kommen.
   - Produktkarte: Slot im Bild, Knopfstil wie der Kaufknopf der Karte (btn--white).
   - Produktseite: an der Stelle des Kaufknopfs, Stil wie der Hauptknopf (btn--primary).
   Rückbau: diese Datei und die Include-Zeile in layout/theme.liquid entfernen. */
(function () {
  var MARKE = 'data-kitsu-notify';
  var ICON =
    '<span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
    ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></span>';

  function oeffnen(handle, url) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!(window._RestockRocket && window._RestockRocket.openModal)) { window.location.href = url; return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { window._RestockRocket.openModal(p, p.variants && p.variants[0] ? p.variants[0].id : null); })
        .catch(function () { window.location.href = url; });
    };
  }

  /* Knopf für die Produktkarte, im Bild, Stil wie der Kaufknopf der Karte. */
  function kartenKnopf(handle, url) {
    var slot = document.createElement('div');
    slot.className = 'product-card__actions product-card__main-actions cpc__notify-slot';
    slot.setAttribute(MARKE, '');
    slot.innerHTML =
      '<button type="button" class="product-card__atc product-card__action-button btn btn--white"' +
      ' data-cpc-notify data-product-handle="' + handle + '" data-product-url="' + url + '" aria-label="Get notified">' +
      ICON + '<span class="product-card__atc-text product-card__action-text">Get notified</span></button>';
    slot.querySelector('[data-cpc-notify]').addEventListener('click', oeffnen(handle, url));
    return slot;
  }

  /* Knopf für die Produktseite, Stil wie der Hauptknopf. */
  function seitenKnopf(handle, url) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'product-form__submit btn btn--primary';
    b.setAttribute(MARKE, '');
    b.setAttribute('data-cpc-notify', '');
    b.setAttribute('data-product-handle', handle);
    b.setAttribute('data-product-url', url);
    b.setAttribute('aria-label', 'Get notified');
    b.textContent = 'Get notified';
    b.addEventListener('click', oeffnen(handle, url));
    return b;
  }

  function handleAusLink(url) {
    var teil = (url || '').split('/products/')[1];
    return teil ? teil.split('?')[0].split('#')[0] : null;
  }

  function bauen() {
    /* Karten */
    var stoqKarten = document.querySelectorAll('.product-card__image-wrapper .restock-rocket-button');
    for (var i = 0; i < stoqKarten.length; i++) {
      var bild = stoqKarten[i].closest('.product-card__image-wrapper');
      if (!bild || bild.querySelector('[' + MARKE + ']')) continue;
      var link = bild.querySelector('a[href*="/products/"]');
      if (!link) {
        var karte = bild.closest('.product-card__wrapper') || bild.closest('.product-card');
        link = karte && karte.querySelector('a[href*="/products/"]');
      }
      if (!link) continue;
      var url = link.getAttribute('href') || '';
      var handle = handleAusLink(url);
      if (!handle) continue;
      var eigene = bild.querySelector('.product-card__actions');
      if (eigene) eigene.remove();
      bild.appendChild(kartenKnopf(handle, url));
    }

    /* Produktseite */
    var formen = document.querySelectorAll('.product-form__buttons');
    for (var j = 0; j < formen.length; j++) {
      var f = formen[j];
      if (!f.querySelector('[class*="restock-rocket-button"]')) continue;
      if (f.querySelector('[' + MARKE + ']')) continue;
      var pfad = window.location.pathname;
      var h = handleAusLink(pfad);
      if (!h) continue;
      f.insertBefore(seitenKnopf(h, pfad), f.firstChild);
    }
  }

  function start() {
    bauen();
    var versuche = 0;
    var takt = setInterval(function () { bauen(); if (++versuche > 20) clearInterval(takt); }, 500);
    if (window.MutationObserver) {
      new MutationObserver(function () { bauen(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
